import { InjectionToken } from '@angular/core';

export const TIMEOUT_VALUE = 30000;
export const TIMEOUT = new InjectionToken<number>('TIMEOUT');

export const URL_BASE_REST_VALUE = 'https://us-central1-dihola-engine-{env}.cloudfunctions.net';
export const URL_BASE_REST = new InjectionToken<string>('URL_BASE_REST');

